import classNames from "@src/utilities/class-names"

function Separator() {
  return (
    <span
      className="mx-2 text-gray-400 text-xs"
      dangerouslySetInnerHTML={{ __html: "&gt;" }}
    />
  )
}

export interface CheckoutBreadcrumbsProps {
  step: "shipping" | "celebration"
}
export default function CheckoutBreadcrumbs({
  step,
}: CheckoutBreadcrumbsProps) {
  return (
    <nav className="font-browser text-xs" data-component="checkout-breadcrumbs">
      <a className="hover:underline" href="/cart">
        Cart
      </a>
      <Separator />
      <a
        className={classNames(
          "pointer-events-none",
          step === "celebration" ? "text-gray-400" : "",
          step === "shipping" ? "font-bold" : ""
        )}
        href="/checkout"
      >
        Shipping + Billing
      </a>
      <Separator />
      <a className="text-gray-400 pointer-events-none" href="/checkout">
        Celebration
      </a>
    </nav>
  )
}
